export default __webpack_public_path__ + "static/media/block22.66e98076.svg";